export default __webpack_public_path__ + "static/media/Livery of the Dragon King.bcf50f11.jpg";